import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { FiCheckCircle, FiAlertCircle } from "react-icons/fi";

// Jednostavan toast za admin akcije (uspeh/greska). Bez zvuka.
const AdminToast = ({ message, type = "success", onClose }) => {
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimateOut(true);
      setTimeout(() => onClose(), 350);
    }, 3000);
    return () => clearTimeout(timeout);
  }, [onClose]);

  return (
    <ToastWrapper
      $hide={animateOut}
      $type={type}
      onClick={() => setAnimateOut(true)}
    >
      {type === "error" ? <FiAlertCircle /> : <FiCheckCircle />}
      <span>{message}</span>
    </ToastWrapper>
  );
};

export default AdminToast;

const slideIn = keyframes`
  from { opacity: 0; transform: translate(-50%, 1.8rem) scale(0.96); }
  to { opacity: 1; transform: translate(-50%, 0) scale(1); }
`;

const slideOut = keyframes`
  from { opacity: 1; transform: translate(-50%, 0) scale(1); }
  to { opacity: 0; transform: translate(-50%, 1.8rem) scale(0.96); }
`;

const ToastWrapper = styled.div`
  position: fixed;
  bottom: 3rem;
  left: 50%;
  z-index: 99999;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  background: rgba(16, 16, 19, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));
  border-left: 3px solid
    ${({ $type }) => ($type === "error" ? "var(--red, #fe5f55)" : "#7dd490")};
  color: var(--text, #f4f2ee);
  padding: 1.3rem 2.2rem;
  border-radius: 0.6rem;
  font-family: "Poppins-Medium";
  font-size: 1.3rem;
  letter-spacing: 0.04em;
  box-shadow: 0 1.8rem 4.2rem -1.4rem rgba(0, 0, 0, 0.85);
  animation: ${({ $hide }) => ($hide ? slideOut : slideIn)} 0.35s
    cubic-bezier(0.22, 0.72, 0.18, 1) forwards;
  max-width: 90vw;

  svg {
    color: ${({ $type }) =>
      $type === "error" ? "var(--red, #fe5f55)" : "#7dd490"};
    flex-shrink: 0;
  }

  svg {
    flex-shrink: 0;
    font-size: 1.8rem;
  }

  @media (max-width: 768px) {
    left: 50%;
    right: unset;
    transform: translateX(-50%);
    top: 1rem;
    font-size: 1.2rem;
    padding: 1rem 1.4rem;
  }
`;
